import { FingeringBeat } from '../types/fingeringEditor';

export interface MeasureLine {
  x: number;
  y1: number;
  y2: number;
  measure: number;
}

// 同じ行と判定する y_bottom の差の閾値
// 一般的な譜面では行間=50〜80px、同行内の微細ズレは<20px程度のため、
// 40 を採用することで「同行内の音符間ズレ」と「行またぎ」を明確に分離できる。
const SAME_ROW_Y_THRESHOLD = 40;

// 行またぎ時に前ビート x からオフセットする量。
// 前ビート直後に小節線を引くことで、「紙面中央の誤中点」問題を回避。
const ROW_CROSSING_X_OFFSET = 10;

/**
 * 小節境界線の座標を計算する。
 *
 * 設計方針:
 * - 同行内の小節境界: 前後ビートの x 中点（従来動作を維持）
 * - 行またぎ小節境界: 前ビートの右側に小節線を引く
 *   （前ビートと次ビートの x 中点だと紙面中央に誤描画されるため）
 *
 * @param beats - 全ビート配列（ページフィルタ前）
 * @param currentPage - 表示中のページ番号
 */
export function computeMeasureLines(
  beats: FingeringBeat[],
  currentPage: number,
): MeasureLine[] {
  const pageBeats = beats.filter((b) => b.page === currentPage);
  if (pageBeats.length < 2) return [];

  const lines: MeasureLine[] = [];
  for (let i = 1; i < pageBeats.length; i++) {
    const prev = pageBeats[i - 1];
    const curr = pageBeats[i];
    if (curr.measure === prev.measure) continue;

    const sameRow = Math.abs(prev.y_bottom - curr.y_bottom) < SAME_ROW_Y_THRESHOLD;
    const x = sameRow
      ? (prev.x + curr.x) / 2
      : prev.x + ROW_CROSSING_X_OFFSET;
    // 同行なら前後ビートの高さの min、行またぎなら前ビート末尾の高さを採用
    const y = sameRow
      ? Math.min(prev.y_bottom, curr.y_bottom)
      : prev.y_bottom;

    lines.push({ x, y1: y - 30, y2: y + 20, measure: curr.measure });
  }
  return lines;
}
